module.exports = __webpack_public_path__ + "img/stripe.37974964.svg";